(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import LabsDataModule from './components/LabsDataModule';
import getTimelineLeukocytes from './timelineData/getTimelineLeukocytes';
import getTimelineHemoglobin from './timelineData/getTimelineHemoglobin';
import getTimelinePlatelets from './timelineData/getTimelinePlatelets';
import getTimelineLymphocytes from './timelineData/getTimelineLymphocytes';
import getTimelineNeutrophils from './timelineData/getTimelineNeutrophils';
import getTimelineEosinophils from './timelineData/getTimelineEosinophils';
import getTimelineBasophils from './timelineData/getTimelineBasophils';
import getTimelineMonocytes from './timelineData/getTimelineMonocytes';
var _default = {
  id: 'plugin-labs',
  path: '/labs',
  name: t('ehr', 'Labs'),
  MenuModule: {
    name: t('ehr', 'Labs'),
    icon: 'Opacity',
    priority: 70
  },
  WidgetModule: {
    name: t('ehr', 'Labs'),
    icon: 'Opacity',
    priority: 70
  },
  DataModule: {
    Component: LabsDataModule
  },
  TimelineModule: [{
    name: t('ehr', 'Blood Test'),
    color: '#ff9063',
    icon: 'Opacity',
    children: [{
      name: 'Leukocytes',
      getData: getTimelineLeukocytes
    }, {
      name: 'Hemoglobin',
      getData: getTimelineHemoglobin
    }, {
      name: 'Platelets',
      getData: getTimelinePlatelets
    }, {
      name: 'Lymphocytes',
      getData: getTimelineLymphocytes
    }, {
      name: 'Neutrophils',
      getData: getTimelineNeutrophils
    }, {
      name: 'Eosinophils',
      getData: getTimelineEosinophils
    }, {
      name: 'Basophils',
      getData: getTimelineBasophils
    }, {
      name: 'Monocytes',
      getData: getTimelineMonocytes
    }]
  }]
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();